function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34",
  height: "24",
  viewBox: "0 0 34 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: ".5",
  y: ".5",
  width: "33",
  height: "23",
  rx: "3.5",
  fill: "#fff",
  stroke: "#D9D9D9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.058 15.528v-2.935h1.515c.62 0 1.144-.208 1.571-.618l.103-.104c.78-.849.728-2.172-.103-2.958a2.161 2.161 0 00-1.571-.63H15.14v7.245h.917zm0-3.824v-2.53h1.538c.33 0 .643.126.877.358.495.485.507 1.293.028 1.796a1.19 1.19 0 01-.905.376h-1.538zm7.465-.746c-.393-.364-.928-.548-1.606-.548-.871 0-1.526.323-1.959.964l.809.514c.296-.438.7-.658 1.213-.658.324 0 .637.121.882.34.24.209.376.51.376.827v.214c-.353-.197-.797-.3-1.344-.3-.637 0-1.15.15-1.531.456-.382.306-.575.71-.575 1.224-.012.468.187.913.54 1.213.36.324.815.486 1.35.486.632 0 1.133-.283 1.515-.85h.04v.688h.876v-3.056c0-.641-.193-1.15-.586-1.514zm-2.488 3.657a.753.753 0 01-.302-.606c0-.272.125-.497.37-.676.25-.18.564-.272.934-.272.512-.005.911.11 1.196.341 0 .393-.154.734-.456 1.023a1.446 1.446 0 01-1.03.433 1.11 1.11 0 01-.712-.243zm5.044 3.09l3.064-7.134h-.997L26.73 14.13h-.017l-1.453-3.559h-.996l2.01 4.64-1.139 2.495h.945z",
  fill: "#3C4043"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.893 11.958c0-.283-.023-.566-.068-.844H8.958v1.6h2.215a1.928 1.928 0 01-.82 1.266v1.04h1.321c.775-.723 1.219-1.791 1.219-3.062z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.958 16.025c1.105 0 2.039-.37 2.716-1.005l-1.32-1.04c-.37.254-.843.398-1.396.398-1.07 0-1.975-.733-2.3-1.715h-1.36v1.074a4.09 4.09 0 003.66 2.288z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.658 12.663a2.544 2.544 0 010-1.595V10h-1.36a4.177 4.177 0 000 3.731l1.36-1.068z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.958 9.353a2.19 2.19 0 011.572.623l1.173-1.19a3.926 3.926 0 00-2.745-1.08c-1.548 0-2.966.89-3.66 2.294l1.36 1.074c.325-.988 1.23-1.721 2.3-1.721z",
  fill: "#EA4335"
})));